<div class="dialog-container expand">
  <div class="dialog-title">
    <div class="dialog-close" (click)="dialogRef.close()"><i class="mdi mdi-close"></i></div>
    <div>{{'REQUEST.FUEL.DELIVERYDATE' | translate}}</div>
    <div class="selected-date">{{selectedDate || date | date: 'EEE, MMMM d'}}</div>
  </div>
  <div class="dialog-body">
    <div class="month-change-box">
      <div class="change-btn" (click)="prevMonth()">
        <i class="mdi mdi-chevron-left"></i>
      </div>
      <div class="current-month">{{'MONTHS.LONG.' + months[selectedMonth] | translate}} {{selectedYear}}</div>
      <div class="change-btn" (click)="nextMonth()">
        <i class="mdi mdi-chevron-right"></i>
      </div>
    </div>
    <table class="date-table">
      <thead>
      <tr>
        <th *ngFor="let day of weekDays">{{'WEEKDAYS.SHORT.' + day | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let week of monthDays">
        <td *ngFor="let day of week">
          <div class="date-btn" [ngClass]="dateBtnClass(selectedYear, selectedMonth, day)"
               (click)="selectDate(selectedYear, selectedMonth, day)">
            <span *ngIf="day" class="day-container">{{day}}</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="restrict-text">{{'REQUEST.FUEL.RESTRICTTEXT' | translate}}</div>
  </div>
</div>

